const ItemType = require('@/lib/Items/ItemType');
/**
 * @param {OrderLine[]} orderLines
 *
 * @return {OrderLine[]}
 */
const getTicketLines = (orderLines) => {
    return orderLines.filter((orderLine) => {
        return orderLine.itemType === ItemType.TICKET && orderLine.qty > 0;
    });
};

/**
 * @param {Order|Cart} orderOrCart
 * @param {number} sessionID
 *
 * @return {OrderLine[]}
 */
const findLinesForSession = (orderOrCart, sessionID) => {
    return orderOrCart.getLines().filter((line) => {
        return line.getSessionID() === sessionID;
    });
};

module.exports = {
    findLinesForSession,
    getTicketLines,
};
